import type { ReactNode } from 'react';
import type { JobBuilderSection, JobDetail } from '@nest-recruit/shared';
import styles from './builder.module.css';

/**
 * What a builder section still needs, in its card's header (Redesign Group 2 mockups): an amber
 * count and the first thing missing, "1 · At least one Must-have". The list is the section's own
 * (`jobSectionStates`), so the header, the section list's count and "Open job" always agree.
 */
export function SectionMissing({ missing }: { readonly missing: readonly string[] }): ReactNode {
  const first = missing[0];
  if (first === undefined) return null;
  return (
    <span className={styles.missing}>
      <span className={styles.missCount} aria-hidden>
        {missing.length}
      </span>
      <span className="sr-only">{missing.length === 1 ? '1 thing to do: ' : `${missing.length} things to do, first: `}</span>
      {first}
    </span>
  );
}

/** A card's `action` slot: the note while something is missing, nothing once complete. */
export function missingAction(missing: readonly string[]): ReactNode {
  return missing.length > 0 ? <SectionMissing missing={missing} /> : undefined;
}

export function sectionMissing(job: JobDetail, section: JobBuilderSection): readonly string[] {
  return job.sections.find((state) => state.section === section)?.missing ?? [];
}
